import { LinkedinLogo, TwitterLogo, InstagramLogo, FacebookLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { Badge } from "@/components/ui/badge";

export const PLATFORM_META = {
  linkedin: { label: "LinkedIn", icon: LinkedinLogo, color: "#0A66C2" },
  twitter: { label: "X / Twitter", icon: TwitterLogo, color: "#111111" },
  instagram: { label: "Instagram", icon: InstagramLogo, color: "#E1306C" },
  facebook: { label: "Facebook", icon: FacebookLogo, color: "#1877F2" },
  newsletter: { label: "Newsletter", icon: EnvelopeSimple, color: "#0047FF" },
};

const STATUS_VARIANT = {
  draft: "outline",
  approved: "secondary",
  scheduled: "default",
  published: "secondary",
};

export function StatusBadge({ status }) {
  return (
    <Badge variant={STATUS_VARIANT[status] || "outline"} className="capitalize font-mono text-xs" data-testid={`status-${status}`}>
      {status}
    </Badge>
  );
}
